module.exports = __webpack_public_path__ + "img/base_activites_motonautisme.0c0136bf.svg";